import {LatmPocComponent} from "./LatmPocComponent";


export function LatmPocScreen() {
  return (<>
    <LatmPocComponent/>
  </>)
}
